import Fragment from './fragment.js'
import Card from './card.js'

import './styles.scss'

export default {
    card: Card,
    fragment: Fragment,
}
